import React, { useState } from "react";
import {
	TextField,
	Modal,
	Fade,
	Button
} from "@material-ui/core";
import MultiSelectTable from "components/Table/MultiSelectTable/MultiSelectTable";
import styles from "Styles.module.scss";

const MultiSelect = (props) => {

	const [openModal, setOpenModal] = useState(false);
	const handleModal = () => {
		setOpenModal(!openModal);
	};
	const handleSelect = (selected) => {
		props.onChange(selected, props.name);
	};


	return (
		<>

			<TextField
				type="text"
				disabled
				onClick={()=>setOpenModal(true)}
				value={props.value ? `${props.value?.length} seleccionados`:"Seleccionar"}
			/>
        
			<Modal open={openModal} onClose={handleModal} className={styles.modal}>
				<Fade in={openModal}>
					<div style={{width:"90%"}} className={styles.paper}>
				
						<MultiSelectTable 
							options={{ filter: true }} 
							selected={props.value}
							type={props.datatype}
							onChange={handleSelect} 
							columns={props.columns} 
							filters={props.filters}
						/>
						<Button variant="contained" color="primary" style={{float:"right"}} onClick={handleModal}>Seleccionar</Button>
					</div>
				</Fade>
			</Modal>
		</>
	);
};

export default MultiSelect;
